import axios from 'axios';
import {useRef, React, useState} from 'react';
import { passwordResetUrl, sendSmsUrl } from '../constants';
import { useNavigate } from 'react-router-dom'
import { emailRegex, phoneRegex } from '../utils';

const ForgetPassword = () => {
    const inputRef = useRef(null);
    const navigate = useNavigate();
    const [err, setErr] = useState(null);

    const onResetPassword = ()=> {
        let email_phone = inputRef.current.value;
        if (emailRegex.test(email_phone))  {
            axios.post(passwordResetUrl, {email: email_phone})
            .then(response=>{
                navigate("/");
            })
            .catch(err=>{
                setErr(err)
            });
        } else if (phoneRegex.test(email_phone)) {
            axios.post(sendSmsUrl, {phone_number: "+1"+email_phone})
            .then(response=>{
                navigate("/verify-phone/rp",{state: {
                    phone: email_phone,
                }});
            })
            .catch(err=>{
                setErr(err)
            });    
        } else {
            setErr("Please enter a valid email address or phone number");
            return;
        }
    };
  return (
    <div class="flex flex-col gap-2 mt-4 lg:mt-8 items-center justify-center">
        {err && <p class="font-bold text-red-500 text-lg">{err}</p>}
        <div  class="flex w-[300px] flex-col gap-2 items-center">
            <label for="email_phone" class="default_text">Email or Mobile Number</label>
            <input id="email_phone" name="email_phone"  ref={inputRef} type="text" placeholder='Email or phone (e.g., 5102988888)' required class="w-full default_input" />
            <button class="default_btn w-full mt-2" onClick={()=>onResetPassword()}>Submit</button>
        </div>
    </div>
  )
}

export default ForgetPassword